import styled, { css } from 'styled-components';
import BackgroundImage from '../../../BackgroundImage';

const StyledBackgroundImage = styled(BackgroundImage)`
  > img {
    ${props =>
      props.isClosed &&
      css`
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
        opacity: 0.8;
      `};
  }
`;

export default StyledBackgroundImage;
